import axios from 'axios'

const API_PATH = '/api/v2/admins/sales/cash_handover_receipts'

const SalesCashHandoverReceiptsApi = {
  index: ({ params }) => axios.get(API_PATH, { params }),

  show: ({ id }) => axios.get(`${API_PATH}/${id}`),

  create: ({ payload }) => axios.post(API_PATH, { cash_handover_receipt: payload }),

  update: ({ id, payload, expectedUpdatedAt, revisionNote }) => axios.patch(`${API_PATH}/${id}`, { cash_handover_receipt: payload, expected_updated_at: expectedUpdatedAt, revision_note: revisionNote }),

  destroy: ({ id }) => axios.delete(`${API_PATH}/${id}`),

  downloadPdf: ({ id }) => axios.get(`${API_PATH}/${id}/download_pdf`, { responseType: 'blob' })
}

export default SalesCashHandoverReceiptsApi
